import Content from 'src/components/Content';
import { AppLayoutWrapper } from './AppLayoutWrapper';

const Home = () => {
    const content = (
        <div style={{ minHeight: 'calc(100vh - 150px)' }}>
            <Content />
        </div>
    );

    return (
        <div data-home-page>
            <AppLayoutWrapper content={content} />
        </div>
    );
};

export default Home;
